<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>基础配置</span>
          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <el-button size="mini" style="margin-left: 10px" type="primary" @click="exportJson()">导出JSON</el-button>
              <syncVersion :in-method="updateConfigCdn" />
            </el-col>
          </el-row>
        </div>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>方块配置</span>
          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <el-upload ref="upload" class="upload-demo" :action="sys_app_logoAction" accept="xlsx" :limit="1" :on-success="(res)=>{return importUploadSuccess(res)}" :headers="headers">
                <el-button :loading="loading" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
              </el-upload>
            </el-col>
            <el-col :span="1.5">
              <el-button type="primary" icon="el-icon-download" size="mini" @click="exportData()">导出</el-button>
            </el-col>
            <el-col :span="1.5">
              <ClearCacheApply />
              <sync-data />
            </el-col>
          </el-row>
        </div>

        <el-table style="border:1px solid #ccc" :data="formData" border stripe>
          <el-table-column prop="id" label="方块ID">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.id" />
            </template>
          </el-table-column>
          <el-table-column prop="name" label="名字">
            <template v-slot:default="scope">
              <el-input v-model="scope.row.name" />
            </template>
          </el-table-column>
          <el-table-column prop="type" label="类型">
            <template v-slot:default="scope">
              <el-select v-model="scope.row.type" placeholder="请选择">
                <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="prob" label="刷新概率(%)">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.prob" placeholder="请输入刷新概率0-100(%) " :min="0" :max="100" @input="validatePositive(scope.row, 'prob')" />
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot:default="scope">
              <el-button type="danger" @click="del(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-button style="margin-top: 10px" type="primary" @click="add()">+</el-button>
        <el-button style="margin-top: 10px" type="primary" @click="onSubmit()">保存</el-button>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import { getBlocksList, updateBlocks, delBlocks, exportBlocks, importBlocks } from '@/api/config/tetris/blocks'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
import SyncVersion from '@/components/SyncVersion/index.vue'
import { updateConfigCdn } from '@/api/config/tetris'
export default {
  name: 'TetrisBlocks',
  components: { SyncData, SyncVersion, ClearCacheApply },
  data() {
    return {
      loading: false,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
      },
      typeOptions: [
        { label: '普通方块', value: 0 },
        { label: '特殊方块', value: 1 }
      ],
      formData: [
        {
          'id': 0,
          'name': '',
          'type': 0,
          'prob': 0
        }
      ]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    updateConfigCdn,
    validatePositive(row, field) {
      const value = parseFloat(row[field])
      if (isNaN(value) || value <= 0) {
        row[field] = 0
      }
      if (value > 100) {
        row[field] = 100
      }
    },
    onSubmit() {
      for (const item of this.formData) {
        const idNum = parseFloat(item.id)
        if (isNaN(idNum) || idNum <= 0) {
          this.msgError('方块ID必须大于0')
          return
        }
        if (!item.name || item.name.trim() === '') {
          this.msgError('名字不能为空')
          return
        }
        if (isNaN(item.prob) || item.prob < 0 || item.prob > 100) {
          this.msgError('刷新概率必须大于等于0且小于等于100')
          return
        }
      }
      const data = JSON.stringify(this.formData)
      updateBlocks({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getBlocksList().then(res => {
        this.formData = res.data || []
      })
    },
    add() {
      this.formData.push({
        'id': 0,
        'name': '',
        'type': 0,
        'prob': 0
      })
    },
    del(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delBlocks({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    importUploadSuccess(response) {
      this.loading = true
      this.$refs.upload.clearFiles()
      importBlocks({ data: response.data.path }).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData() {
      exportBlocks().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportJson() {
      window.open(process.env.VUE_APP_BASE_API + '/api/v1/export/exportTetrisConfigJson')
    }
  }
}
</script>

<style scoped>
</style>
